import {REGISTRY_RETAILER_API_HOST} from '../constants/app';
import apiFetch from './utils/apiFetch';

const RegistryRetailerApi = {
  getRetailers: async () => {
    const options = {
      method: 'GET',
    };
    const url = `${REGISTRY_RETAILER_API_HOST}/v1/retailers?eventType=wedding`;
    const tokenErrorDescription =
      'RegistryRetailerApi.getRetailers requires a token';
    const res = await apiFetch(url, options, tokenErrorDescription);

    if (!res.ok) {
      const error = new Error(res.statusText);
      error.status = res.status;
      throw error;
    }

    const jsonResponse = await res.json();

    return jsonResponse;
  },
};

export default RegistryRetailerApi;
